/** Stato abilitazione XFIR per unità locale (localStorage, demo locale). */

export function xfirStorageKey(sitoId: string): string {
  return `rentri.xfirEnabled.${sitoId}`;
}

export function isXfirEnabled(sitoId: string): boolean {
  return localStorage.getItem(xfirStorageKey(sitoId)) === "1";
}
